
import { Drawer } from "element-ui"
import { getUserNotificatioMsgDetail } from "@/api/notification"
import { renderedLinkText } from "@/utils/utils"

export default {
  name: "NotificationDetail",
  components: {
    [Drawer.name]: Drawer
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    msgId: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      curVisible: this.visible,
      detail: {}
    }
  },
  watch: {
    visible: {
      immediate: true,
      handler(val) {
        this.curVisible = val
        if (val) {
          this.getDetail()
        }
      }
    }
  },
  methods: {
    renderedLinkText,
    async getDetail() {
      const params = {
        msgId: this.msgId
      }
      const { data } = await getUserNotificatioMsgDetail({ param: JSON.stringify(params) })
      this.detail = data
    },
    handleClose() {
      this.$emit("close")
    }
  }
}
